<div>


  <div class="dash-section m-5 bg-white ">
  <div class="d-flex flex-column p-2 bd-highlight">
    <ul class="nav nav-pills mb-3 " id="pills-tab" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Send Notification</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false" (click)="getNotificationMessage()">View Notification history
       <div *ngIf="!loadNotificationSpin" class="spinner-border spinner-border-sm ml-4" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" id="pills-send-sms-tab" data-toggle="pill" href="#pills-send-sms" role="tab" aria-controls="pills-send-sms" aria-selected="false">Send Sms</a>
    </li>

    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">

      <form >

        <div class="form-group">
          <label for="application">Application</label>
          <select name="notfiApp"  [(ngModel)]="notfiApp" class="form-control" id="application">
            <option value="farmer">Farmer App</option>
            <option value="agent">Agent App</option>
          </select>
        </div>

        <div class="form-group">
          <label for="screenandmodule">Module</label>
          <select name="notfiModule"  [(ngModel)]="notfiModule" class="form-control" id="screenandmodule">
            <option value="agric_shop">AgriShop</option>
            <option value="market">Market</option>
            <option value="garden_mapping">GardenMapping</option>
            <option value="records">Records</option>
            <option>dashboard</option>
            <option>AgriShop</option>
          </select>
        </div>

        <div class="form-group">
          <label for="exampleFormControlInput1">Title</label>
          <input  name="notfiTitle" [(ngModel)]="notfiTitle" type="text" class="form-control" id="exampleFormControlInput1" placeholder="information title ....">
        </div>

        <!--
        <div>
          <input type="file" (change)="notficationImageChanged($event)">
        </div>
        -->
        <div class="form-group">
          <label for="infotextarea">Message</label>
          <textarea name="notfiMessage"  [(ngModel)]="notfiMessage" class="form-control" id="infotextarea" rows="3"></textarea>
        </div>

        <!--notification and spinner zone-->
        <div>
        <button type="submit" class="btn btn-primary" (click)="sendNotificationMessage()" style="background-color:#77b8e9;">Send</button>
        <div *ngIf="!sendSpin" class="spinner-border spinner-border-sm ml-4" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <span *ngIf="!sendSpin" class="ml-4">sending notification</span>
        <span *ngIf="sendSpin" class="ml-4">{{res_message}}</span>
        </div>
      </form>

      </div>

      <!--modal for details-->
      <!-- The Modal -->
      <div *ngIf="specificNotification" class="modal fade" id="myModal">
        <div class="modal-dialog">
          <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">{{specificNotification.development.title}}</h4>
              <br/>
              <div>
                <span class="badge badge-primary">{{specificNotification.development.application}} app</span>
                <span class="badge badge-info">{{specificNotification.development.module}} module</span>
              </div>
              <button type="button" class="close" (click)="hideModal()">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <p>{{specificNotification.development.message}}</p>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
            <p *ngIf="failedMessage">{{failedMessage}}</p>
              <button type="button" class="btn btn-primary" (click)="sendModal()" >Resend
                <div *ngIf="!reloadNotificationSpin" class="spinner-border spinner-border-sm ml-4" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </button>
              <button type="button" class="btn btn-danger" (click)="hideModal()">Close</button>

              <!-- this button is hidden, used to close from typescript -->
              <button type="button" id="close-modal" data-dismiss="modal" style="display: none">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
       <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Date</th>
              <th scope="col">App</th>
              <th scope="col">Module</th>
              <th scope="col">Title</th>
              <th scope="col">Message</th>
              <th scope="col">More</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="
                let row of notificationInfos
                  | paginate: { itemsPerPage: count, currentPage: page };
                  let i = index
              ">
            <td> {{(page - 1) * count + i+1}}</td>
            <td>{{ row.development.date }}</td>
            <!--<td><img src='{{ "https://storage.googleapis.com/ezyagric-media" + row.test.photo_url }}' width="80" height="80" alt="{{row.test.crop}}" /></td> -->
            <td>{{ row.development.application }}</td>
            <td>{{ row.development.module }}</td>
            <td>{{ row.development.title }}</td>
            <td>{{ row.development.message | slice:0:30 }}<a class="pl-3" href="">...</a></td>
            <td><a type="button" class="btn btn-primary" data-toggle="modal" data-target="#myModal" (click)="showModal(row)" style="background-color:#77b8e9; color:#fff;">Details</a></td>
            <td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tab-pane fade" id="pills-send-sms" role="tabpanel" aria-labelledby="pills-send-sms-tab">
        <form (ngSubmit)="sendSms()" #addform="ngForm">
          <div class="form-group">
            <label for="smstextarea">Message:</label>
            <textarea name="message"  [(ngModel)]="message" class="form-control" id="smstextarea" rows="3" required></textarea>
          </div>
          <span *ngIf="messageErrors" class="alert alert-danger">{{ messageError}}</span>
          <div class="form-group">
            <div class="d-flex justify-content-between">
              <div class="custom-control custom-radio">
                <input type="radio" id="tosingleperson" name="recipient" value="tosingleperson" (click)="setList(true)" [checked]='true' ngModel>
                <label for="tosingleperson">Single Contact</label>
                <input *ngIf="singleContact" name="singleRecipient" [(ngModel)]="singleRecipient" type="text" class="form-control" id="to" placeholder="e.g. +256788929118 ...">
              </div>
              <div class="custom-control custom-radio">
                <input type="radio" id="togroupofpeople" value="contactsList" name="recipient" (click)="setList(false)" ngModel>
                <label for="users">Attach csv file for list of contacts</label>
                <input *ngIf="!singleContact" type="file" accept=".csv,.xlsx" (change)="handleFileSelect($event)"
                  class="form-control change-input-field" name="users" required/>
              </div>
            </div>
          </div>
          <div class="alert alert-danger" *ngIf="errors">{{ errors }}</div>
          <div>
            <button class="btn btn-success"
              data-dismiss="modal"
              data-toggle="modal"
              data-target="#inputModal"
              type="submit"
              [disabled]="!addform.form.valid"
            >
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Send
              </span>
            </button>
          </div>
        </form>
        <div class="modal fade" id="inputModal">
          <div class="modal-dialog change-modal-dialog" role="document">
            <app-success-modal
              *ngIf="statusCode && res_message"
              [message]="res_message"
            >
            </app-success-modal>
          </div>
        </div>
      </div>
    </div>
</div>
